import React from 'react';

const AgeBadge = ({ ageDays, ageingBands = [] }) => {
  const band = ageingBands.find(b => ageDays >= b.minDays && ageDays <= b.maxDays);
  const color = band ? band.colorHex : '#9ca3af';

  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 3,
      fontSize: 9, fontFamily: "'JetBrains Mono', monospace", fontWeight: 600,
    }}>
      <span style={{
        width: 5, height: 5, borderRadius: '50%', backgroundColor: color,
        display: 'inline-block', flexShrink: 0,
      }} />
      {ageDays}d
    </span>
  );
};

export default AgeBadge;
